import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../../context/App-Context";
import axios from "axios";
import BubbleImportFunction from "../../BubblesJSONcommandPanel.json/BubbleImportFunction";
import BubbleDisplayImg from "../TgridEditorForm/bubblesDisplay/BubbleDisplayImg";

const TgridFlexPostItems = (props) => {
  const [data, setData] = useState(null);
  const [dataForBubbles, setDataForBubbles] = useState(null);
  const [postPhotos, setpostPhotos] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Helper to strip year and timezone for the grid view
  const formatShortTime = (timeStr) => {
    if (!timeStr) return "";
    return timeStr
      .replace(/, \d{4}/, "")
      .replace(/\s*[a-z]{3}$/i, "")
      .trim();
  };
  const BUBBLE_KIT_MAP = {
    HUM1: "human",
    HOM2: "home",
    GEO3: "geo",
    FIR4: "fireworks",
    P3D5: "portrait3d",
    TRP6: "portraittrap",
    AFR7: "portraitafrica",
    AFZ8: "portraitafricazone",
    AFW9: "africawesttrap",
    AFS0: "africasouthtrap",
    LTK1: "letterkit",
    LHK2: "letterhebrewkit",
    LHT3: "letterhebrewtextkit",
    LGT4: "lettergreektextkit",
    WDK1: "wordkindkit",
    WDH2: "wordhidekit",
    WDA3: "wordanimalkit",
    WKC4: "wordkindcontourkit",
    WNC5: "wordnocontourkit",
    WAC6: "wordanimalcontourkit",
    CTK7: "customtextcontourkit",
    ROD1: "road",
    CAR1: "car",
    CUB1: "carcube",
    CBT2: "carcubetilt",
    CBS3: "carcubesegment",
    CBF4: "carcubefused",
    CBA5: "carcubealign",
    AUR1: "aura",
    RDO1: "radarone",
    RDT2: "radartwo",
    GUA1: "guardian",
    GHO1: "ghost",
    STR1: "starlight",
    HPR1: "humanpresence",
    RBW1: "starspirit",
  };

  // 1. NEW: State to track which photo is currently fullscreen in the feed
  const [previewPhoto, setPreviewPhoto] = useState(null);

  const auth = useContext(AuthContext);

  // const auth = useContext(AuthContext);

  // 🌟 1. RESOLVE ID: Handles whether postFunction is an object or a string
  const postId =
    typeof props.postFunction === "object"
      ? props.postFunction.uid || props.postFunction._id
      : props.postFunction;

  const handleBubblesClick = () => {
    if (props.onEditPost && data) {
      props.onEditPost({
        uid: postId, // Safely uses the extracted ID
        postText: data.postText,
        postDate: data.postDate,
        postImages: postPhotos || [], // 🌟 2. THE FIX: Pass the pre-fetched, S3 signed photos array!
      });
    }
  };

  useEffect(() => {
    setData(null);
    setError(null);
    setLoading(true);
    if (!postId) return; // Exit if no ID

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/func-rts-upst/getImagesTempleGridpost?username=${auth.loginVar}&uid=${postId}` // 🌟 Updated to postId
        );
        setpostPhotos(response.data.data.functionGo);
      } catch (err) {
        // console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [auth.loginVar, postId]); // 🌟 Updated dependency

  useEffect(() => {
    setData(null);
    setError(null);
    setLoading(true);
    if (!postId) return; // Exit if no ID

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/func-rts-upst/gettgridpost/${auth.loginVar}/${postId}` // 🌟 Updated to postId
        );
        setData(response.data.functionGO);
        //console.log(response.data.functionGO);
      } catch (err) {
        // console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [auth.loginVar, postId]); // 🌟 Updated dependency

  ///////////////// useEffect
  ///////// get bubbles
  ///////

  useEffect(() => {
    //console.log(props.postFunction);

    // console.log(response.data.functionGO)

    if (data && data.postBubbles) {
      // console.log(data.postBubbles);

      const fetchData = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/func-rts-upst/getTempleGridPostBubbles/${data.postBubbles}`
          );
          setDataForBubbles(response.data.data.functionGo);
          //console.log(response.data.data);
          //  console.log(response.data.data.functionGo);
          //console.log(auth);
        } catch (err) {
          // console.log(err.message);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [auth.loginVar, data]);

  let activePreviewKit = "none";

  if (dataForBubbles) {
    // Safely check if it's an array or a single object based on your DB return
    const firstBubble = Array.isArray(dataForBubbles)
      ? dataForBubbles[0]
      : dataForBubbles;

    // Grab the 4-character code (e.g. "CBA5") OR fallback to the old activeKit if migrating
    const rawHiddenCode =
      firstBubble?.activeKitCode ||
      firstBubble?.templeGridpostBubblesData?.activeKitCode ||
      firstBubble?.activeKit;

    // Translate "CBA5" -> "carcubealign" so the canvas knows what to draw
    activePreviewKit = BUBBLE_KIT_MAP[rawHiddenCode] || rawHiddenCode || "none";
  }

  // useEffect(() => {
  //   setData(null);
  //   setError(null);
  //   setLoading(true);

  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/func-rts-upst/getTempleGridPostBubbles/${props.postFunction}`
  //       );
  //       //setDataForBubbles(response.data.functionGO);
  //     } catch (err) {
  //       // console.log(err.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, [auth.loginVar, props.postFunction]);

  //////////////////////////////////////////////
  /////////// add bubbles

  // Example: convert processed canvases to blobs if you want overlays in the final post

  return (
    <div>
      {/* 2. NEW: The Fullscreen Modal Overlay for Feed Photos */}
      {/* {previewPhoto && (
        <div
          className="photo-preview-modal"
          onClick={() => setPreviewPhoto(null)}
        >
          <button
            className="close-preview-btn"
            onClick={() => setPreviewPhoto(null)}
          >
            ×
          </button>
          <img
            src={previewPhoto}
            alt="Fullscreen preview"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )} */}
      {/* 2. NEW: The Fullscreen Modal Overlay with Live Tensor Rendering */}
      {previewPhoto && (
        <div
          className="photo-preview-modal"
          onClick={() => setPreviewPhoto(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.95)", // Clean white frosted background
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            className="close-preview-btn"
            onClick={() => setPreviewPhoto(null)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              background: "none",
              color: "#00008b",
              border: "none",
              fontSize: "50px", // Bumped slightly to keep it large and easy to tap
              cursor: "pointer",
              zIndex: 10000,
              fontWeight: "100", // <-- Changed from "bold" to "100" for an ultra-thin line
              lineHeight: "0.5", // Keeps the hit-box tight around the thin X
            }}
          >
            ×
          </button>

          {/* THE MODULAR TENSOR LENS */}
          {/* THE MODULAR TENSOR LENS */}
          {/* THE MODULAR TENSOR LENS */}
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "90%",
              maxWidth: "800px",
              height: "80vh",
              position: "relative",
            }}
          >
            <BubbleDisplayImg
              src={previewPhoto.url}
              activeKit={activePreviewKit}
              showOcancer={false} // <-- Changed to TRUE so the blue border shows!
            />

            {/* Show Full Timestamp in Modal */}
            {previewPhoto.time && (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "15px",
                  color: "#00008b",
                  fontWeight: "bold",
                }}
              >
                {previewPhoto.time}
              </div>
            )}
          </div>
        </div>
      )}

      {data && (
        <div>
          <article key={data.uid} className="post-card">
            <div className="post-header">
              <span className="avatar">👑</span>
              <span className="username">{auth.loginVar}</span>
              <span className="timestamp">{data.postDate}</span>
            </div>
            <p className="post-text">{data.postText}</p>

            {/* {postPhotos && (
              <div>
                <div className="photo-grid">
                  {postPhotos.map((photo, index) => (
                    <div
                      key={photo.key || photo.filename || `photo-${index}`}
                      className="photo-item"
                      role="button"
                      tabIndex={0}
                      // 3. NEW: Triggers the modal when clicking a feed photo
                      onClick={() => setPreviewPhoto(photo.url || photo.src)}
                    >
                      <img
                        src={photo.url || photo.src}
                        alt={photo.filename || `Photo ${index + 1}`}
                        className="photo-img"
                        loading="lazy"
                        onError={(e) =>
                          console.error("Image load failed:", photo.url)
                        }
                      />

                      {photo.caption && (
                        <div className="photo-caption">{photo.caption}</div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )} */}

            {/* Photo Grid */}
            {postPhotos && (
              <div>
                <div className="photo-grid">
                  {postPhotos.map((photo, index) => {
                    // 🌟 FULL BULLETPROOF EXTRACTION (Added .img and .image)
                    // 🌟 FULL BULLETPROOF EXTRACTION (Added singular .postImage)
                    const imgSrc =
                      photo.url ||
                      photo.img ||
                      photo.image ||
                      photo.src ||
                      photo.postImage || // 🌟 ADDED THIS LINE
                      photo.postImages ||
                      photo.StarPostImages ||
                      photo.StarFormsImages ||
                      (typeof photo === "string" ? photo : "");
                    const imgTime =
                      photo.time ||
                      photo.timestamp ||
                      (data?.imageTimestamps
                        ? data.imageTimestamps[index]
                        : null);

                    return (
                      <div
                        key={photo.key || photo.filename || `photo-${index}`}
                        role="button"
                        tabIndex={0}
                        onClick={() =>
                          setPreviewPhoto({
                            url: imgSrc, // Safely passes the extracted URL to the modal
                            time: imgTime,
                          })
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          marginBottom: "16px",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="photo-item"
                          style={{ margin: 0, width: "100%" }}
                        >
                          <img
                            src={imgSrc}
                            alt={photo.filename || `Photo ${index + 1}`}
                            className="photo-img"
                            loading="lazy"
                            style={{
                              width: "100%",
                              height: "auto",
                              display: "block",
                            }}
                          />
                        </div>

                        {imgTime && (
                          <div
                            style={{
                              marginTop: "8px",
                              textAlign: "left",
                              paddingLeft: "4px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#007bff",
                                fontWeight: "bold",
                              }}
                            >
                              {formatShortTime(imgTime)}
                            </span>
                          </div>
                        )}

                        {photo.caption && (
                          <div
                            className="photo-caption"
                            style={{ textAlign: "left", marginTop: "4px" }}
                          >
                            {photo.caption}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="post-footer">
              {/* <button>🔥</button> */}

              {dataForBubbles && (
                <div
                  className="active-bubbles-display"
                  style={{
                    marginTop: "12px",
                    paddingTop: "12px",
                    borderTop: "1px solid #00008b",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                  }}
                >
                  {dataForBubbles.map((bubbleItem) => (
                    <div>
                      <BubbleImportFunction
                        // key={index}
                        showBubbles={bubbleItem.activeKit}
                        showCode={bubbleItem.hiddenCode}
                      />
                    </div>
                  ))}
                </div>
              )}

              {/* <button>⚡</button>
              <button>📤</button> */}
            </div>
            <div
              className="bubbles-area"
              onClick={handleBubblesClick}
              style={{
                cursor: "pointer",
                padding: "8px",
                background: "#f0f0f0",
                borderRadius: "6px",
                marginTop: "8px",
              }}
            >
              Bubbles <span style={{ fontSize: "1.2em" }}>+</span>
            </div>
          </article>
        </div>
      )}
    </div>
  );
};

export default TgridFlexPostItems;
